import { useEffect, useId, useState } from 'react'

type Props = {
  value: string
  options: string[]
  ariaLabel: string
  onCommit: (value: string) => void
}

/** Ô vừa gõ vừa chọn: gõ để lọc gợi ý, chỉ ghi nhận khi khớp một giá trị có trong báo giá. */
export function QuoteChoiceInput({ value, options, ariaLabel, onCommit }: Props) {
  const listId = useId()
  const [draft, setDraft] = useState(value)
  useEffect(() => setDraft(value), [value])

  const match = (text: string) => options.find((o) => o.trim().toLowerCase() === text.trim().toLowerCase())

  return (
    <>
      <input
        type="text"
        list={listId}
        className="cell-input w-full text-right"
        aria-label={ariaLabel}
        value={draft}
        onChange={(e) => {
          const text = e.target.value
          setDraft(text)
          const hit = match(text)
          if (hit !== undefined && hit !== value) onCommit(hit)
          else if (text === '' && value !== '') onCommit('')
        }}
        onBlur={() => setDraft(value)}
      />
      <datalist id={listId}>
        {options.map((o) => <option key={o} value={o} />)}
      </datalist>
    </>
  )
}
